module.exports = __webpack_public_path__ + "img/瓜蒌皮.328f0e73.jpg";